import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import {
  getSkill,
  listSkills,
  listAvailableSkills,
} from "@/lib/data/requests/skills";
import type { SkillScope } from "@/lib/data/schemas/skills";
export const skillsQueryKey = ["skills"] as const;
export const skillsQueryOptions = (scope: SkillScope) =>
  infiniteQueryOptions({
    queryKey: [...skillsQueryKey, "list", scope],
    queryFn: ({ pageParam }) => listSkills(scope, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
export const skillDetailQueryOptions = (id: string) =>
  queryOptions({
    queryKey: [...skillsQueryKey, "detail", id],
    queryFn: () => getSkill(id),
    staleTime: 0,
  });

export const availableSkillsQueryOptions = (search: string) =>
  infiniteQueryOptions({
    queryKey: [...skillsQueryKey, "available", search],
    queryFn: ({ pageParam }) => listAvailableSkills(search, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
